const OPTIONS = [
  { id: "by_departure", name: "Por Salidas" },
  { id: "by_arrival", name: "Por Llegadas" },
];

const guestOptions = [
  { id: "main_guest", name: "Huesped Principal" },
  { id: "all_guests", name: "Huesped Principal con sus acompañantes" },
];

function layout() {
  const ctxView = {
    model: "hotel.guests_list",
    reportName: "hotel.guests_list.report",
    description: "Lista de Huéspedes",
    fields: {
      operation_center: {
        type: "many2one",
        model: "company.operation_center",
        required: true,
      },
      date: {
        type: "date",
        required: true,
      },
      filter: {
        type: "selection",
        required: true,
        options: OPTIONS,
      },
      show_guests: {
        type: "selection",
        required: true,
        options: guestOptions,

      },
    },
    list: [],
    form: [
      { name: "operation_center" },
      { name: "date" },
      { name: "filter" },
      { name: "show_guests" },
    ],
  };

  return ctxView;
}

export { layout };
